<div [ngClass]="{'mobile': isMobile}">
  <div class="content">
    @if (displayAccountManagerList.length) {
      <ds-autocomplete id="accountManager" class="fill-width" [ngClass]="{'quarter-width': !isMobile}"
        [options]="displayAccountManagerList" [label]="appStrings.quoteDetails_AccountManager" label_orientation="vertical-label"
        [control]="quoteDetailsForm.controls.accountManager" [isDisabled]="quoteDetailsForm.controls.accountManager.disabled"
        (selectionChange)="onAccountManagerSelected($event)">
      </ds-autocomplete>
    }

    <ds-paper class="dark-paper spaced-bottom" [ngClass]="isMobile ? 'full-width-paper' : 'customer-container'" elevation="elevation_none" borderRadius="radius_S"
      outline="outlined" [insidePaddingTop]="isMobile ? 'top-spacing_S' : 'top-spacing_XL'" insidePaddingBottom="bottom-spacing_3XS" insidePaddingLeft="left-spacing_L"
      insidePaddingRight="right-spacing_L">
      <div class="card-container">
        <ds-autocomplete id="customer" class="no-subscript fill-width"  [ngClass]="{'input-card-content' : !isMobile}" [options]="displayCustomerList"
          [label]="appStrings.quoteDetails_Customer" label_orientation="vertical-label" [control]="quoteDetailsForm.controls.customer"
          [isDisabled]="quoteDetailsForm.controls.customer.disabled" (selectionChange)="onCustomerSelected($event)" fullFilter="true">
        </ds-autocomplete>
        <ds-checkbox (change)="hideInactiveCustomersToggle()" [ngClass]="{'checkbox-card-content' : !isMobile}" [label]="appStrings.product_gridHideInactive" id="hideInactiveCustomersCheckbox"
          [control]="quoteDetailsForm.controls.hideInactiveCustomers" [isDisabled]="quoteDetailsForm.controls.hideInactiveCustomers.disabled">
        </ds-checkbox>
      </div>
    </ds-paper>

    @if (isFederalCustomer) {
      <ds-select id="federalPriorityCode" class="fill-width" [ngClass]="{'quarter-width': !isMobile}" [label]="appStrings.quoteDetails_Federal"
        [dropOptions]="displayFederalPriorityCodeList" label_orientation="vertical-label" [control]="quoteDetailsForm.controls.federalPriorityCode"
        [isDisabled]="quoteDetailsForm.controls.federalPriorityCode.disabled">
      </ds-select>
    }

    <ds-textfield id="quoteName" class="fill-width" [ngClass]="{'third-width fill-gap': !isMobile}" [label]="appStrings.quoteDetails_quoteName" label_orientation="vertical-label"
      [control]="quoteDetailsForm.controls.quoteName" [isDisabled]="quoteDetailsForm.controls.quoteName.disabled" maxLength="20">
    </ds-textfield>

    @if (currentCustomer?.isLead && priceAsEnabled) {
      <ds-autocomplete id="priceAs" class="fill-width" [ngClass]="{'quarter-width': !isMobile}"
        [label]="appStrings.quoteDetails_PriceAs" [options]="displayPriceAsList" label_orientation="vertical-label" fullFilter="true"
        [control]="quoteDetailsForm.controls.priceAs" [isDisabled]="quoteDetailsForm.controls.priceAs.disabled" (selectionChange)="onPriceAsSelected($event)">
      </ds-autocomplete>
    }

    <ds-autocomplete id="priceMatrix" class="fill-width" [ngClass]="{'quarter-width': !isMobile}" [label]="appStrings.quoteDetails_PriceMatrix"
      [options]="displayPriceMatrixList" label_orientation="vertical-label" [control]="quoteDetailsForm.controls.priceMatrix"
      [isDisabled]="quoteDetailsForm.controls.priceMatrix.disabled" (selectionChange)="onPriceMatrixSelected($event)">
    </ds-autocomplete>

    @if (!isLead) {
      <ds-select id="defaultRoute" class="fill-width" [ngClass]="{'quarter-width': !isMobile}" [label]="appStrings.quoteDetails_DefaultRoute"
        [dropOptions]="displayDefaultRouteList" label_orientation="vertical-label" [control]="quoteDetailsForm.controls.defaultRoute"
        [isDisabled]="quoteDetailsForm.controls.defaultRoute.disabled">
      </ds-select>
    }

    @if (!isLead) {
      <ds-select id="confidenceToClose" class="fill-width" [ngClass]="{'quarter-width': !isMobile}" [label]="appStrings.quoteDetails_ConfidenceToClose"
        [dropOptions]="displayConfidenceOptionsValues" label_orientation="vertical-label" [control]="quoteDetailsForm.controls.confidenceToClose"
        [isDisabled]="quoteDetailsForm.controls.confidenceToClose.disabled" (selectionChange)="updateConfidence($event.value)">
      </ds-select>
    }

    @if (displayEstimatedDate) {
      <ds-date-picker id="estimatedCloseDate" class="fill-width" [ngClass]="{'quarter-width fill-gap': !isMobile}" [label]="appStrings.quoteDetails_EstimatedCloseDate"
        label_orientation="vertical-label" [control]="quoteDetailsForm.controls.estimatedCloseDate" [isDisabled]="quoteDetailsForm.controls.estimatedCloseDate.disabled"
        [date_format]="dsDateFormat"
        (dateChange)="updateCloseDate($event.value)">
      </ds-date-picker>
    }

    @if (displayQuoteCalendarExpirationDate && !isLead && !hasItemsFromCW) {
      <ds-date-picker id="quoteExpireDate" class="fill-width" [ngClass]="{'quarter-width': !isMobile}"
        [label]="appStrings.quote_expireLabelCalendar" label_orientation="vertical-label" [control]="quoteDetailsForm.controls.quoteExpireDate"
        [isDisabled]="quoteDetailsForm.controls.quoteExpireDate.disabled"
        [date_format]="dsDateFormat">
      </ds-date-picker>
    }

    <ds-multiline id="quoteNotes" class="fill-width" [label]="appStrings.quoteDetails_Notes" label_orientation="vertical-label" [control]="quoteDetailsForm.controls.quoteNotes"
      [isDisabled]="quoteDetailsForm.controls.quoteNotes.disabled" maxLength="2000">
    </ds-multiline>

    <div class="button-container">
      <ds-button size="medium" type="secondary" variant="label-only" [label]="appStrings.button_continue" id="continueButton" (onClick)="goToProductList.emit()">
      </ds-button>
    </div>
  </div>
</div>

<ds-dialog
  [title]="dialogTitle"
  [description]="dialogText"
  [actionButtons]="dialogButtons"
  [open]="dialogOpen$"
  disableClose="true">
</ds-dialog>